(function () {

    a3_cabin_reports.directive('traineeSyllabus', traineeSyllabus);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name traineeSyllabus
   * @restrict E
   * @description
   *   Initialize read only view of submitted syllabus
   * @example
   *   Usage:
   *   <trainee-syllabus></trainee-syllabus>
   * @ngInject
   */

    function traineeSyllabus() {
        function link(scope) {           
            setSyllabus(scope.traineeSession);
            function setSyllabus(traineeSession) {
                var traineeSessionItems = [];
                scope.phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (item) {
                    if(item.Active == true){
                        var syllabusItem = JSON.parse(JSON.stringify(item));
                        syllabusItem.Tries = [];
                        syllabusItem.Selected = false;
    
                        var relatedSessionItem = null;
                        if(scope.type == "signature"){
                            relatedSessionItem = traineeSession.Items.find(x => x.Id == syllabusItem.Id);
                        }
                        else{
                            relatedSessionItem = traineeSession.Items.find(x => x.SyllabusItemId == syllabusItem.Id);                      
                        }
  
                        if(relatedSessionItem){
                            syllabusItem.Selected = true;
                            syllabusItem.Tries = relatedSessionItem.Tries;
                            syllabusItem.hasRemarks = relatedSessionItem.Tries.some(x => x.Comments && x.Comments.length>0) ||
                            relatedSessionItem.Tries.some(t=> t.TryGrading.Competences.some(x => x.Comments && x.Comments.length>0));
                            syllabusItem.Tries.forEach(function(attempt){
                                attempt.Selected = true;
                        });
                        }
    
                        if(scope.type == "signature"){
                            setPanelStyleByProgress(syllabusItem); 
                        }
                        else{
                            setPanelStyleBySelected(syllabusItem); 
                        }                   
                        traineeSessionItems.push(syllabusItem);
                    }
                
                });
               
                scope.traineeSession.ItemsGrouped = [];
                scope.traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);            
            }

            function setPanelStyleByProgress(item){
                var historyTriesCount = item.Tries.length;
                var newTriesCount = item.Tries.filter(x => !x.isReadOnly && x.Selected).length;
                item.TriesPerformedCount = historyTriesCount + newTriesCount;

                var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

                if(item.MandatoryCount == 0){   //non-mandatory items are considered completed if performed at least once
                    completedItem = item.TriesPerformedCount>=1;
                }

                if(completedItem){
                    item.PanelClass = 'panel-green panel-border-left-green ';
                }
                else{
                    item.PanelClass = 'panel-border-left-blue ';
                }
            }

            function setPanelStyleBySelected(item){
                var historyTriesCount = item.Tries.length;
                
                item.TriesPerformedCount = historyTriesCount;

                var completedItem = item.TriesPerformedCount >= item.Mandatory;

                if(completedItem){
                    item.PanelClass = 'panel-green panel-border-left-green ';
                }
                else{
                    item.PanelClass = 'panel-border-left-blue ';
                }
            }

            function SyllabusGrouping(items) {
                //Syllabus Items Group By 'GroupId'
                var syllabusGroups = [];
                items.forEach(function (item) {
                    if (!syllabusGroups.some(x => x.Id == item.SelectedGroup.Id)) {
                        if (!item.SelectedGroup) {
                            item.SelectedGroup = {
                                Id: 0,
                                Title: 'General'
                            };
                        }

                        var syllabusGroup = {
                            Id: item.SelectedGroup.Id,
                            Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
                            Items: []
                        };

                        syllabusGroup.Items.push(item);
                        syllabusGroups.push(syllabusGroup);
                    }
                    else {
                        syllabusGroups.filter(x => x.Id == item.SelectedGroup.Id)[0].Items.push(item);
                    }
                });

                return syllabusGroups;
            }

        }
        return {
            restrict: 'E',
            templateUrl: 'views/TraineeCourse/trainee-syllabus.tpl.html',
            scope : { phase:"=", traineeSession:"=", type:"="},
            terminal: true,
            link: link
        }
    }
})();